module.exports = __webpack_public_path__ + "assets/soscardio-ico-pickdate.8da40b28.svg";